import { ABPopupMessageLayout } from '../../../../common/lookups/Layouts/ABLayouts';
import { WMCodeTypesLookupLayout } from '../../../../common/lookups/Layouts/WMLayouts';

const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CodeType",
                "tableName": "WMCODES",
                "label": "Type",
                "type": "lookup",
                "layout": WMCodeTypesLookupLayout({ valueExpr: 'CodeType', displayExpr: 'Description' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code",
                "tableName": "WMCODES",
                "label": "Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "Description1",
                "tableName": "WMCODES",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "WMCODES",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "Comment",
                "tableName": "WMCODES",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "CreationDateTime",
                "tableName": "WMCODES",
                "label": "Creation Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "CreationUserId",
                "tableName": "WMCODES",
                "label": "Creation User",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "LastUpdateDateTime",
                "tableName": "WMCODES",
                "label": "Last Update Date Time",
                "type": "datetime",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 5,
        "label": "",
        "fields": [
            {
                "name": "LastUpdateUserId",
                "tableName": "WMCODES",
                "label": "Last Update User",
                "type": "text",
                "required": false,
                "visible": false,
                "isLabelChanged": false,
            }
        ]
    }
];

// CodeType + Code are the composite key: read-only after creation (Delphi uABD0000). Pass
// isEdit=true on the edit page so they can't be changed (the server also ignores key-field edits).
const HeaderLayout = (isEdit = false) => [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "CodeType",
                "tableName": "WMCODES",
                "label": "Type",
                "type": "lookup",
                "layout": WMCodeTypesLookupLayout({ valueExpr: 'CodeType', displayExpr: 'Description' }),
                "lookupDisplayMode": "grid",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": false,
            },
            {
                "name": "Code",
                "tableName": "WMCODES",
                "label": "Code",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
                "readOnly": false,
            },
            {
                "name": "Description1",
                "tableName": "WMCODES",
                "label": "Description 1",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description2",
                "tableName": "WMCODES",
                "label": "Description 2",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Comment",
                "tableName": "WMCODES",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "PopupMessage",
                "tableName": "WMCODES",
                "label": "Popup Message",
                "type": "lookup",
                "layout": ABPopupMessageLayout({ tableName: 'WMCODES' }),
                "lookupDisplayMode": "grid",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export { SearchLayout, HeaderLayout };
